<template>
  <span
    v-if="compact"
    data-slot="rule-type-badge"
    :class="[ 'relative inline-flex size-6 shrink-0 items-center justify-center rounded-md', style.bg ]"
  >
    <i :class="[ 'icon white size-4', style.icon ]" />
    <i v-if="ai" :class="[ 'icon magic-stars absolute -top-2 -right-2 size-3.5', style.bg ]" />
    <span class="sr-only">{{ label }}</span>
  </span>
  <span
    v-else
    data-slot="rule-type-badge"
    :class="[ 'inline-flex w-fit items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-semibold text-white', style.bg ]"
  >
    <i :class="[ 'icon white size-3.5', style.icon ]" />
    {{ label }}
    <i v-if="ai" class="icon magic-stars white size-3.5" />
  </span>
</template>

<script>
import { ruleActionStyle } from '@/ui/utils/ruleAction.js';

const LABELS = {
  start: 'Ad Creation',
  scaling_up: 'Ad Scaling',
};

/** Colored automation type mark: an icon square (`compact`) or a labeled badge. */
export default {
  name: 'RuleTypeBadge',
  props: {
    action: {
      type: String,
      required: true,
    },
    ai: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    compact: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    style() {
      return ruleActionStyle(this.action);
    },
    // stop, smart_stop and delete all read as "Ad Stop".
    label() {
      return this.tr(LABELS[this.action] || 'Ad Stop');
    },
  },
};
</script>
